
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Nouveau personnage</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">        
            <form [formGroup]="characterSheetForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label for="nom">Nom :</label>
                <input type="text" formControlName="nom" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['nom'].errors }">
                <div *ngIf="submitted && f['nom'].errors" class="invalid-feedback">
                  <div *ngIf="f['nom'].errors['required']">Nom requis</div>
                </div>
              </div>        
              <div class="form-group">
                <label for="legion">Légion : </label>
                <select formControlName="legion" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['legion'].errors }" (change)="onLegionChange()">
                  <option [ngValue]="null" disabled>Choisir Légion</option>
                  <option *ngFor="let legion of legions.values | keyvalue" [ngValue]="legion.key">{{legion.value}}</option>
                </select>
                <div *ngIf="submitted && f['legion'].errors" class="invalid-feedback">
                  <div *ngIf="f['legion'].errors['required']">Légion requise</div>
                </div>
              </div>    
              <div class="form-group">
                <label for="astre1">Premier Astre : </label>
                <select formControlName="astre1" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['astre1'].errors }">
                  <option [ngValue]="null" disabled>Choisir Premier Astre</option>
                  <option *ngFor="let astre of astres.values | keyvalue" [ngValue]="astre.key">{{astre.value}}</option>
                </select>
                <div *ngIf="submitted && f['astre1'].errors" class="invalid-feedback">
                  <div *ngIf="f['astre1'].errors['required']">Premier Astre requis</div>
                  <div *ngIf="f['astre1'].errors['epouvantailAstreError']">L'épouvantail ne peut pas être né sous cet astre.</div>
                </div>
              </div>    
              <div class="form-group" [hidden]="!isHumain">
                <label for="astre2">Second Astre : </label>
                <select formControlName="astre2" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['astre2'].errors }">
                  <option [ngValue]="null" disabled>Choisir Second Astre</option>
                  <option *ngFor="let astre of astres.values | keyvalue" [ngValue]="astre.key">{{astre.value}}</option>
                </select>
                <div *ngIf="submitted && f['astre2'].errors" class="invalid-feedback">
                  <div *ngIf="f['astre2'].errors['required']">Second Astre requis</div>
                </div>
              </div>
                <input type="submit" value="Créer" class="btn btnPrimary mt-3" >
            </form>    
          </div>
        </div>
      </div>
    </div>
  </div>